import React from 'react';
import { __ } from 'i18n-for-browser';
import { connect } from 'react-redux';
import PopupTitle from '../elements/PopupTitle';
import GameMaterials from '../elements/GameMaterials';

import apiCall from "../apiCall";
import GoBackButton from '../elements/GoBackButton';

import actions from '../../actions';
class Prepare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generalMaterial: [],
      project: {},
    }
  }

  componentWillMount() {
    this.fetchMaterials();
    document.body.classList.add('schoolPage');
  }

  fetchMaterials() {
    const { languageId, difficultyId, projectId } = this.props.match.params;
    const promises = [
      apiCall(`/project/${projectId}/public`, null, 'GET'),
      apiCall(`/generalMaterial/${languageId}/${difficultyId}/preparation`, null, 'GET'),
    ];
    Promise.all(promises)
      .then(([project, generalMaterial]) => {
        this.setState({ generalMaterial, project: project || {}});
      });

    // Force update language in gamestate to fix issue with popups always being dutch on prepare page
    this.props.dispatch(actions.gameState.forceUpdateLanguage(parseInt(languageId, 10) === 2 ? "EN" : "NL"));
  }

  render() {
    const { generalMaterial, project } = this.state;
    const { history } = this.props;
    if (!project.id) return null;
    return (
      <div className="classleader-prepare portal-home darkBckg desktop-single">
        <div className={'container general-materials-container'}>
          <div className={'title-block'}>
            <GoBackButton history={history} closeWindow/>
            <PopupTitle forceLanguage={parseInt(this.props.match.params.languageId, 10) === 2 ? "EN" : "NL"} popupId="dhbvtvoorbereiding" tag={'h3'}/>
            <p>{__('sim_docent')}</p>
            {project.expired ? <p style={{ marginTop: '20px' }}>{__('sim_project_is_verlopen_melding')}</p> : null}
          </div>
          {!project.expired ? <GameMaterials projectId={this.state.project ? this.state.project.id : null} items={generalMaterial} /> : null}
        </div>
      </div>
    );
  }
}

export default connect(state => state)(Prepare);



// WEBPACK FOOTER //
// ./src/components/routes/PreparePublic.js